import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

/**
 * IndexPage - Root Route Handler
 *
 * Redirects root path "/" to "/auto-apply-setup/resume" with search params preserved.
 * For nested routes, renders <Outlet /> to allow child route rendering.
 */
const IndexPage: React.FunctionComponent = () => {
    const location = useLocation();

    // Redirect root path to auto-apply-setup/resume (SSR-compatible)
    if (location.pathname === '/') {
        return <Navigate to={`/auto-apply-setup/resume${location.search}`} replace />;
    }

    // Render nested routes
    return <Outlet />;
};

export default IndexPage;
